import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

export const Footer = ({
  showCta = true,
  logoSrc = '/headline-tool-tans.png',
  ctaTitle = 'Want a Complete LinkedIn Profile Optimization?',
  ctaDescription = 'Use our LinkedIn Profile Optimizer tool to analyze and optimize your entire LinkedIn profile for better visibility and engagement.',
  ctaHref = 'https://optimizer.growleads.io/',
  ctaButtonText = 'Try LinkedIn Profile Optimizer',
  brandLabel = 'Linkedin Headline Generator',
  footerLinkHref = 'https://optimizer.growleads.io/',
  footerLinkText = 'LinkedIn Profile Optimizer',
}) => {
  return (
    <footer className="py-10 md:py-12 border-t border-border">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* CTA Section */}
        {showCta && (
          <div className="text-center mb-8 p-6 rounded-2xl bg-primary/5 border border-primary/10">
            <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground mb-3">
              {ctaTitle}
            </h3>
            <p className="text-muted-foreground mb-6 max-w-lg mx-auto">
              {ctaDescription}
            </p>
            <Button variant="primary" size="lg" asChild>
              <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="gap-2">
                {ctaButtonText}
                <ExternalLink className="w-4 h-4" />
              </a>
            </Button>
          </div>
        )}

        {/* Footer Info */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-4">
          <a href="https://growleads.io" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
            <img 
              src={logoSrc} 
              alt="Growleads.io Logo" 
              className="w-8 h-8 rounded-lg object-contain"
            />
            <div>
              <span className="font-display font-semibold text-foreground">{brandLabel}</span>
            </div>
          </a>
          
          <div className="flex flex-col md:flex-row items-center gap-4 text-sm text-muted-foreground">
            <a 
              href={footerLinkHref} 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors flex items-center gap-1"
            >
              {footerLinkText}
              <ExternalLink className="w-3 h-3" />
            </a>
            <span className="hidden md:inline">•</span>
            <span>&copy; {new Date().getFullYear()} Growleads.io All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
